import {cleanStyle} from "@/edinet/libs/utils_jq";
import $ from "jquery";

function valueReplacer(f: (v: number) => number) {
    return function replacer(match: string, pre: string, width: string, unit: string): string {
        // console.log('replacer %o, %o, %o, %o', elem.tagName, pre, width, unit)
        if (width && unit) {
            const w = parseFloat(width)
            const w2 = f(w)
            return `${pre}${w2}${unit}`
        } else {
            console.warn('unexpected case. do nothing: %o, %o, %o', match, width, unit)
            return match
        }
    }
}

function adjFont(root: JQuery, f: (v: number) => number) {
    const adj = valueReplacer(f)
    cleanStyle(root, (style) => {
        style = style.replace(RegExp(String.raw`([^-]font-size:\s*)([\d.]+)([a-zA-Z]+)`, 'g'), adj)
        style = style.replace(RegExp(String.raw`(^font-size:\s*)([\d.]+)([a-zA-Z]+)`, 'g'), adj)
        style = style.replace(RegExp(String.raw`([^-]line-height:\s*)([\d.]+)([a-zA-Z]+)`, 'g'), adj)
        style = style.replace(RegExp(String.raw`(^line-height:\s*)([\d.]+)([a-zA-Z]+)`, 'g'), adj)
        return style
    })
}

function updateValue(attr: string, f: (v: number) => number, tag?: string) {
    return function(style: string, elem: Element) {
        // console.log(elem)

        function replacer(match: string, pre: string, width: string, unit: string): string {
            // console.log('replacer %o, %o, %o, %o', elem.tagName, pre, width, unit)
            if (width && unit) {
                const w = parseFloat(width)
                const w2 = f(w)
                return `${pre}${w2}${unit}`
            } else {
                console.warn('unexpected case. do nothing: %o, %o, %o, %o', style, match, width, unit)
                return match
            }
        }

        if (!tag || elem.tagName === tag) {
            // style = style.replace(/([^-]width:\s*)([\d.]+)([a-zA-Z]+)/g, replacer)
            style = style.replace(RegExp(String.raw`([^-]${attr}:\s*)([\d.]+)([a-zA-Z]+)`, 'g'), replacer)
            // style = style.replace(/(^width:\s*)([\d.]+)([a-zA-Z]+)/g, replacer)
            style = style.replace(RegExp(String.raw`(^${attr}:\s*)([\d.]+)([a-zA-Z]+)`, 'g'), replacer)
        }
        return style
    }
}

function cleanStyleTag($doc: JQuery, clean: (style: string, elem: Element) => string) {
    //<style>...</style> tag
    $doc.find('style').each(function() {
        const $style = $(this)
        let style = $style.html()
        style = clean(style, this)
        $style.html(style)
    })
}

function updateJqRootStyle($doc: JQuery, updateFn: (style: string, elem: Element) => string) {
    const style = $doc.attr('style')
    // console.log(style)
    if (style) {
        const updated = updateFn(style, $doc.get()[0])
        // console.log(updated)
        $doc.attr('style', updated)
    }
}

export class JqStyle {
    jqRootId: string
    scaleUpFactor: number
    scaleDnFactor: number

    constructor(jqRootId: string, step = 0.1) {
        this.jqRootId = jqRootId
        this.scaleUpFactor = 1 + step
        this.scaleDnFactor = 1 / (1 + step)
    }

    root() {
        return $('#' + this.jqRootId)
    }

    widthUp() {
        cleanStyleTag(this.root(), updateValue('width', x => x * this.scaleUpFactor))
        updateJqRootStyle(this.root(), updateValue('max-width', x => x * this.scaleUpFactor))
    }

    widthDown() {
        cleanStyleTag(this.root(), updateValue('width', x => x * this.scaleDnFactor))
        updateJqRootStyle(this.root(), updateValue('max-width', x => x * this.scaleDnFactor))
    }

    fontUp() {
        adjFont(this.root(), x => x * this.scaleUpFactor)
    }

    fontDown() {
        adjFont(this.root(), x => x * this.scaleDnFactor)
    }
}